module.exports = "<ngx-loading-bar height=\"4px\" [includeSpinner]=\"false\"></ngx-loading-bar>\r\n<router-outlet></router-outlet>"